module.exports = __webpack_public_path__ + "static/media/ao1.e2174c6f.png";